module.exports = __webpack_public_path__ + "static/media/emblem.240bec03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/emblem.png
// module id = 781
// module chunks = 0